// @flow
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';
import { INSIGHT_GENERAL_OVERVIEW } from '../routing/InsightRouteConstants';
import { isUserAuthenticated } from '../../store/selector/UserSelector';
import { LOGIN } from '../../common/routing/RouteConstants';

const InsightPageNotFound = (): React$Node => {
  const authenticated = useSelector(isUserAuthenticated);

  let navigateTo = LOGIN;
  if (authenticated) {
    navigateTo = INSIGHT_GENERAL_OVERVIEW;
  }

  console.debug('Route not found! Redirecting to fallback');

  return <Navigate to={navigateTo} replace />;
};

export default InsightPageNotFound;
